import { Component, ElementRef, Renderer2, ViewChild } from "@angular/core";
import { WhitelabelService } from "../whitelabel.service";

@Component({
  selector: "app-terms-privacy",
  templateUrl: "./terms-privacy.component.html",
  styleUrls: ["./terms-privacy.component.scss"],
})
export class TermsPrivacyComponent {
  currentPopUpFrom: string;
  @ViewChild("readMoreSelectorModal") readMoreModal: ElementRef;
  constructor(
    public whitelabelService: WhitelabelService,
    private renderer: Renderer2
  ) {}

  openReadMoreModal(event, from) {
    event.preventDefault();
    this.currentPopUpFrom = from;
    this.renderer.removeClass(this.readMoreModal.nativeElement, "hide");
  }

  OnCheckOutsideClose() {
    this.currentPopUpFrom = "";
    this.renderer.addClass(this.readMoreModal.nativeElement, "hide");
  }
}
